import { Button, Indicator } from "@hulahoop/ui";
import { ChatCircle } from "@phosphor-icons/react";
import { IconTooltip } from "@/components/shared/overlays/IconTooltip";
export function ShellCommentsTrigger({
  open,
  unread,
  label,
  unreadLabel,
  onToggle,
}: {
  open: boolean;
  unread: boolean;
  label: string;
  unreadLabel: string;
  onToggle: () => void;
}) {
  return (
    <IconTooltip label={label}>
      <Button
        variant="ghost"
        size="icon-sm"
        aria-label={label}
        aria-pressed={open}
        onClick={onToggle}
      >
        {unread ? (
          <Indicator label={unreadLabel} tone="info">
            <ChatCircle />
          </Indicator>
        ) : (
          <ChatCircle />
        )}
      </Button>
    </IconTooltip>
  );
}
